import { ISummaryTableDataNode } from 'components/common/SummaryTable/SummaryTable.properties';

const schema: ISummaryTableDataNode[] = [
    {
        objectName: 'quoteSummaryPanel',
        isLoading: '',
        title: 'Quote details',
        children: [
            {
                label: 'QUOTE',
                fieldNames: [
                    'DocumentNumber'
                ],
            },
            {
                label: 'CUSTOMER',
                fieldNames: [
                    'CustomerDisplay',
                    'CustomerDisplayLabel',
                ],
                valueRenderer: {
                    hyperLink: {
                        link: false,
                        menu: true
                    },
                    api: {
                        api: '/customermaintenance/lookup/action',
                        name: 'Customer',
                        params: {
                            queryFields: {
                                CustomerId: 'Customer',
                                SearchText: ''
                            }
                        }
                    }
                }
            },
            {
                label: 'SALES ENTITY',
                fieldNames: [
                    'SalesEntity',
                    'SalesEntityDescription',
                ],
            },
            {
                label: 'WAREHOUSE',
                fieldNames: [
                    'Warehouse',
                    'WarehouseDescription',
                ],
            },
            {
                label: 'QUOTE STATUS',
                fieldNames: [
                    'QuoteStatus',
                ],
            },

        ]
    },
    {
        objectName: 'quoteSummaryPanel',
        isLoading: '',
        children: [
            {
                label: 'ENTERED',
                fieldNames: [
                    'EnteredDate',
                ],
            },
            {
                label: 'EXPIRY',
                fieldNames: [
                    'ExpiryDate',
                ],
            },
        ]
    },
    {
        objectName: 'quoteSummaryPanel',
        isLoading: '',
        label: 'Totals',
        children: [
            {
                label: 'CURRENCY',
                fieldNames: [
                    'Currency',
                ],
                valueRenderer: {
                    isNumericDisplay: true
                }
            },
            {
                label: 'TAX TOTAL',
                fieldNames: [
                    'TaxTotalDisplay',
                ],
                valueRenderer: {
                    isNumericDisplay: true
                }
            },
            {
                label: 'QUOTE TOTAL',
                fieldNames: [
                    'QuoteTotalDisplay',
                ],
                valueRenderer: {
                    isNumericDisplay: true
                }
            },
        ]
    },
];

export default schema;
